/* @flow */
import * as React from 'react';
import { observable } from 'mobx';
import { translate } from 'react-i18next';

//----------------------------------------------------------------------//
// GLOBAL COMPONENTS                                                    //
//----------------------------------------------------------------------//

import * as LocationApi from 'api/Location/LocationApi';

import ListExpandable from 'components/ListExpandable';
import ListRow from 'components/ListExpandable/ListRow';
import NavigationService from 'services/NavigationService';

//----------------------------------------------------------------------//
//----------------------------------------------------------------------//

@translate()
export default class WorkspacesExpandableList extends React.Component<*> {
  @observable workspaces: Object = {};

  async getWorkspaces(locationId: string, siteId: string): Array<Object> {
    if (!Object.prototype.hasOwnProperty.call(this.workspaces, siteId)) {
      this.workspaces[siteId] = await LocationApi.getLocationWorkspaces(locationId, siteId);
    }

    return this.workspaces[siteId];
  }

  renderList = (workspaces: Array<Object>) => {
    const { t } = this.props;

    if (!workspaces) {
      return null;
    }

    return workspaces.map((workspace: Object) => (
      <ListRow
        key={workspace.id}
        text={workspace.name}
        textMiddle={workspace.parent_names}
        textRight={`${workspace.assets_count} ${t('general:asset', {
          count: workspace.assets_count,
        })}`}
        button={true}
        link={true}
        url={NavigationService.formulateReportViewUri(`/assets/`, {
          page: 1,
          filters: [{ key: 'location', values: [workspace.id] }],
        })}
        buttonText={t('general:actions.view_asset', { count: workspace.assets_count })}
        buttonDisabled={workspace.assets_count <= 0}
      />
    ));
  };

  render(): ?React.Element<*> {
    const { details }: Object = this.props;

    if (!details.hierarchy.site) {
      return null;
    }

    const site: Object = details.hierarchy.site;

    return (
      <section>
        <h3>{this.props.title}</h3>
        <ListExpandable
          title={`${site.name} (${details.workspaces ? details.workspaces[site.id] : 1})`}
          render={this.renderList}
          onExpand={async () => await this.getWorkspaces(details.id, site.id)}
        />
      </section>
    );
  }
}
